import { groupBy } from 'fp-ts/es6/NonEmptyArray'
import { toArray } from 'fp-ts/es6/Record'
import {sortBy} from "fp-ts/es6/Array";
import * as N from "fp-ts/es6/number";
import { pipe } from "fp-ts/es6/function";
import {contramap} from "fp-ts/es6/Ord";

export type TileKey =
    'yandexSatellite'
    | 'yandexMap'
    | 'GIS'
    | 'OSM'
    | 'googleMap'
    | 'googleSatellite'
    | 'googleHybrid'
    | 'openWeather'
    | 'bing'
    | 'bingSatellite'

export type TileConfiguration = typeof Tiles[keyof typeof Tiles]

export const Tiles = {
    // TODO! Нужен корректный адрес с тайлами, но как я понял,
    // сейчас "Народная" это обычная карта, с программно нанессенной информацией
    //
    // yandexPeople: {
    //     url: '//core-sat.maps.yandex.net/tiles?l=sat&v=3.1033.0&x={x}&y={y}&z={z}&lang=ru_RU',
    //     options: { subdomains: '1234' },
    //     name: 'Яндекс.Народная',
    //     group: 'Яндекс'
    // },
    yandexSatellite: {
        url: 'https://core-sat.maps.yandex.net/tiles?l=sat&v=4.55.2&z={z}&x={x}&y={y}&scale=2&lang=ru_RU',
        options: { subdomains: '1234' },
        name: 'Яндекс.Спутник',
        group: 'Яндекс'
    },
    yandexMap: {
        url: 'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&v=4.55.2&z={z}&x={x}&y={y}&scale=2&lang=ru_RU',
        options: { subdomains: '1234' },
        name: 'Яндекс.Карты',
        group: 'Яндекс'
    },
    OSM: {
        url: '//{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        options: { subdomains: 'abc' },
        name: 'OpenStreetMap',
        group: 'OpenWeatherMap'
    },
    openWeather: {
        url: '//maps.openweathermap.org/maps/2.0/relief/{z}/{x}/{y}?appid=49b234cf1c354ef3584567e6223d6b21',
        options: { subdomains: '' },
        name: 'OpenWeatherMap.Рельеф',
        group: 'OpenWeatherMap'
    },
    googleSatellite: {
        name: 'Google.Спутник',
        url: 'https://mt{1-3}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
        options: { subdomains: '123' },
        group: 'Google'
    },
    googleMap: {
        name: 'Google.Карта',
        url: 'https://mt{1-3}.google.com/vt/lyrs=r&x={x}&y={y}&z={z}',
        options: { subdomains: '123' },
        group: 'Google'
    },
    googleHybrid: {
        name: 'Google.Гибрид',
        url: 'https://mt{1-3}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
        options: { subdomains: '123' },
        group: 'Google'
    },
    bingSatellite: {
        name: 'Bing.Спутник',
        url: '',
        options: { imagerySet: 'AerialWithLabels' },
        group: 'Bing'
    },
    bing: {
        name: 'Bing.Карта',
        url: '',
        options: { imagerySet: 'Road' },
        group: 'Bing'
    },
    GIS: {
        url: 'https://tile1.maps.2gis.com/tiles?x={x}&y={y}&z={z}',
        name: '2GIS',
        options: {},
        group: '2GIS'
    },
} as const

const byGroupOrder = pipe(
    N.Ord,
    contramap(
    ([groupName]: [string, (TileConfiguration & { id: string })[]]) => (
        Object.values(Tiles).map(t => t.group as string).indexOf(groupName)
    ))
);

const byTileOrder = pipe(
    N.Ord,
    contramap(
        (
            (tile: TileConfiguration & { id: string }) => (
                Object.keys(Tiles).indexOf(tile.id)
            ))
        )
    );

export const TilesByGroup: [string, (TileConfiguration & { id: string })[]][] =
    sortBy([byGroupOrder])(toArray(groupBy<TileConfiguration & { id: string }>(x => x.group)(toArray(Tiles).map(([k, v]) => ({
        ...v,
        id: k
    }))))).map(([k, v]) => ([k, sortBy([byTileOrder])(v)]))
